import {
  SET_USER_INFO,
  SET_PAG_INS,
  SET_CURR_POINT,
  SET_CAN_AUTO_PLAY,
  SET_AUDIO_LOADED,
} from './constants'
export const commonSet = 'commonSet'
export default {
  [commonSet](state: any, data: any) {
    const { key, value } = data
    state[key] = value
  },
  [SET_USER_INFO](state: any, data: any) {
    state.userInfo = data
  },

  [SET_CURR_POINT](state: any, data: any) {
    state.currPoint = data
  },

  [SET_PAG_INS](state: any, data: any) {
    state.pagIns = data
  },

  [SET_CAN_AUTO_PLAY](state: any, data: any) {
    state.canAutoPlay = data
  },

  [SET_AUDIO_LOADED](state: any, data: any) {
    state.audioLoaded = data
  },
}
